<template>
  <v-btn
    :class="[{ fadeOutBtn: !isScrolled || isScrolling }]"
    color="#fff"
    fab
    dark
    class="back-to-top"
    @click="btnClick"
  >
    <img src="@/assets/img/icon/backtop.svg" alt="" />
  </v-btn>
</template>

<script>
export default {
  name: 'BackToTop',
  props: {
    isScrolled: {
      type: Boolean,
      default: false,
    },
    isScrolling: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {}
  },
  computed: {},
  mounted: function() {},
  methods: {
    btnClick() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style scoped lang="scss">
.back-to-top {
  position: fixed;
  right: 17px;
  bottom: 15vh;
  z-index: 10;
  width: 40px !important;
  height: 40px !important;
  overflow: hidden;
  transition: bottom 0.3s;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  &.fadeOutBtn {
    bottom: -230px;
  }
}
</style>
